export const getParsedMark = (mark) => {
  if (mark !== 0 && (mark === null || mark === undefined)) return '';
  return isNaN(parseFloat(mark)) ? mark : parseFloat(mark);
};
